<template>
  <div class="VideoPlayer">
    <iframe
      :src="vidSrc"
      :height="height"
      ref="videoIframe"
      frameborder="0"
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
    ></iframe>
  </div>
</template>

<script>
export default {
  props: {
    vidSrc: {
      default: ""
    }
  },
  data() {
    return {
      height: "250px"
    };
  },
  mounted() {
    // setTimeout(() => {
    //   this.height = (this.$refs.videoIframe.clientWidth / 16) * 9 + "px";
    //   console.log(this.height);
    // }, 2000);
  }
};
</script>

<style>
.VideoPlayer iframe {
  width: 100%;
  max-height: 600px;
  max-width: 800px;
  /* height: 100%; */
}
</style>



// WEBPACK FOOTER //
// VideoPlayer.vue?a0006462